export default "__VITE_ASSET__DnTmNRV6__"